<div class="container">
  <div class="page-title">
    <div>
      <hyperkit-breadcrumb-list
        class="breadcrumb-list"
        [items]="breadcrumbs()"
        (breadcrumbClick)="onBreadcrumbClick($event)"
      >
      </hyperkit-breadcrumb-list>
      <hyperkit-typography
        display="block"
        variant="h1"
        align="left"
        color="primary"
        >Edit Tool</hyperkit-typography
      >
    </div>
    <div class="buttons">
      <hyperkit-button
        (click)="saveTool()"
        [disabled]="!toolForm.valid"
        size="small"
        variant="standard"
        text="Save Changes"
        color="tertiary"
      ></hyperkit-button>
      <hyperkit-button
        (click)="deleteTool()"
        size="small"
        variant="icon"
        icon="trash"
        color="secondary"
      ></hyperkit-button>
    </div>
  </div>
  <div class="tool-wrapper">
    <hyperkit-banner
      [type]="'warning'"
      text=" Environment changes will apply only to future hunts; existing hunts will remain unchanged."
      [closable]="true"
    ></hyperkit-banner>
    <form
      style="width: 100%"
      [formGroup]="toolForm"
      class="k-form pt-4"
      [ngClass]="{ editing: isEditing }"
    >
      <fieldset class="k-form-fieldset">
        <hyperkit-typography
          display="block"
          variant="h4"
          align="left"
          color="primary"
          >Tool Details</hyperkit-typography
        >
        <hyperkit-input
          #name
          class="hyperkit-component"
          type="text"
          label="Name"
          formControlName="name"
        ></hyperkit-input>
        <kendo-formfield class="product-select">
          <kendo-label [for]="product" text="Tool"></kendo-label>
          <kendo-dropdownlist
            #product
            formControlName="product"
            [style.width]="'100%'"
            [data]="groupedData"
            textField="name"
            valueField="name"
            [valuePrimitive]="true"
            (valueChange)="valueChange($event)"
          >
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <img width="20px" [src]="getToolIcon(dataItem.name)" />
              <hyperkit-typography
                display="block"
                variant="body"
                align="left"
                size="sm"
                color="primary"
                >{{ dataItem.name }}</hyperkit-typography
              >
            </ng-template>
          </kendo-dropdownlist>
          <kendo-formerror>Tool is required</kendo-formerror>
        </kendo-formfield>
        @if (supportedToolUrl(toolForm.value.product)) {
          <kendo-formfield>
            <hyperkit-input
              #name
              class="hyperkit-component"
              type="text"
              label="Root URL"
              placeholder="https://www.tool.example.com/"
              formControlName="rootUrl"
            ></hyperkit-input>
            <!-- <div style="float: right">
                  <hyperkit-button (click)="testUrl()" [disabled]="toolForm.controls.rootUrl.invalid" size="small" variant="link" text="Test" color="secondary"></hyperkit-button>
                </div> -->
          </kendo-formfield>
        }
      </fieldset>
      @if (customMapping) {
        <fieldset class="k-form-fieldset">
          <div>
            <div class="section-header">
              <hyperkit-typography
                display="block"
                variant="h4"
                align="left"
                color="primary"
                >Field Mappings</hyperkit-typography
              >
              <hyperkit-button
                style="float: right"
                (click)="addFieldMapping()"
                size="small"
                variant="standard"
                icon="plus"
                color="tertiary"
                text="Add Field Mapping"
              ></hyperkit-button>
            </div>
            <div class="mt-4" formArrayName="fieldMappings">
              @for (
                fieldMapping of fieldMappings().controls;
                track fieldMapping;
                let i = $index
              ) {
                <details
                  [formGroupName]="i"
                  [attr.open]="openIndexes.has(i) || null"
                  (toggle)="onToggle(i, $event)"
                >
                  <summary>
                    @if (fieldMapping.value.name) {
                      <hyperkit-typography
                        display="block"
                        variant="body"
                        size="lg"
                        align="left"
                        color="primary"
                        >{{
                          fieldMapping.value.name
                        }}&nbsp;</hyperkit-typography
                      >
                    } @else {
                      <hyperkit-typography
                        display="block"
                        variant="body"
                        size="lg"
                        align="left"
                        color="primary"
                        >Field Mapping {{ i + 1 }}</hyperkit-typography
                      >
                    }
                  </summary>
                  <div class="content">
                    <fieldset class="k-form-fieldset">
                      <hyperkit-typography
                        display="block"
                        variant="h4"
                        align="left"
                        color="primary"
                        >Field Mapping Details</hyperkit-typography
                      >
                      <hyperkit-input
                        #name
                        class="hyperkit-component"
                        type="text"
                        label="Name"
                        formControlName="name"
                      ></hyperkit-input>
                      <div formArrayName="toolSpecific">
                        @for (
                          field of toolSpecificFields(i).controls;
                          track field;
                          let j = $index
                        ) {
                          <ng-container [formGroupName]="j">
                            <hyperkit-input
                              #name
                              class="hyperkit-component"
                              type="text"
                              label="{{ getReadableName(getFieldName(field)) }}"
                              formControlName="{{ getFieldName(field) }}"
                            ></hyperkit-input>
                          </ng-container>
                        }
                      </div>
                    </fieldset>
                    <fieldset class="k-form-fieldset">
                      <div class="section-header">
                        <hyperkit-typography
                          display="inline"
                          variant="h4"
                          align="left"
                          color="primary"
                          >Field Mapping Configuration</hyperkit-typography
                        >
                        <hyperkit-button
                          (click)="applyDefaults(i)"
                          size="small"
                          [disabled]="fieldMapping.value.category.length === 0"
                          variant="standard"
                          color="tertiary"
                          text="Apply Defaults"
                        ></hyperkit-button>
                      </div>
                      <hyperkit-select
                        class="category-select"
                        (selectionChange)="populateCategoryFields($event, i)"
                        [valueProperty]="'category'"
                        [displayProperty]="'name'"
                        label="Category"
                        [options]="categoryData"
                        formControlName="category"
                      ></hyperkit-select>
                      <div formArrayName="fields">
                        @for (
                          field of fieldMappingFields(i).controls;
                          track field;
                          let j = $index
                        ) {
                          <ng-container [formGroupName]="j">
                            <hyperkit-input
                              #name
                              class="hyperkit-component"
                              hint="{{
                                getFieldDescription(getFieldName(field))
                              }}"
                              type="text"
                              label="{{
                                getReadableFieldName(getFieldName(field))
                              }}"
                              formControlName="{{ getFieldName(field) }}"
                            ></hyperkit-input>
                          </ng-container>
                        }
                      </div>
                      <hyperkit-button
                        style="float: right"
                        (click)="removeFieldMapping(i)"
                        size="small"
                        variant="standard"
                        icon="trash"
                        color="destructive"
                        text="Delete"
                      ></hyperkit-button>
                    </fieldset>
                  </div>
                </details>
              }
            </div>
          </div>
        </fieldset>
      }
    </form>
  </div>
</div>

<!-- </div> -->
<!-- </div> -->
<ng-template #loading>
  <div class="loading">
    <kendo-loader type="pulsing" themeColor="primary" size="large">
    </kendo-loader>
  </div>
</ng-template>
<!-- </section> -->
